import MonoBehavior from "../lib/MonoBehavior";
import Vector2 from "../math/Vector2";
import SPBogey from "./SPBogey";
import SPPlayer from "./SPPlayer";

export default class SPScanner extends MonoBehavior {

    get player(): SPPlayer {return this.gameObject.GetScript(SPPlayer);}

    Draw(): void {
        for (const bogey of this.engine.GetGameObjectsBehaviors<SPBogey>(SPBogey).filter(
            v => !v.isBoss
        )) {

            this.ctx.fillStyle = '#ff555555';
            this.engine.FillRect(bogey.transform.position.add(new Vector2(-25, -(bogey.size + 8))), new Vector2(50, 4));
            this.ctx.fillStyle = '#ff5555';
            this.engine.FillRect(bogey.transform.position.add(new Vector2(-25, -(bogey.size + 8))), new Vector2(50 * (bogey.hp/bogey.maxHP), 4));

        }
    }

}